import {
  endOfMonth,
  endOfToday,
  endOfYesterday,
  startOfMonth,
  startOfToday,
  startOfYesterday,
  subMonths,
  subWeeks,
} from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { getWeekEnd, getWeekStart } from "@app/util/dates";

import DateRangeType from "../enums/DateRangeType";

const dateRangeTypeToDateRange = (
  dateRangeType: DateRangeType,
  includeToday: boolean = false
): DateRange | undefined => {
  const anchor = includeToday ? Date.now() : startOfYesterday();
  const anchorEnd = includeToday ? endOfToday() : endOfYesterday();
  switch (dateRangeType) {
    case DateRangeType.LAST_WEEK:
      return {
        endDate: getWeekEnd(subWeeks(Date.now(), 1)),
        startDate: getWeekStart(subWeeks(Date.now(), 1)),
      };
    case DateRangeType.PREVIOUS_MONTH:
      return {
        endDate: endOfMonth(subMonths(Date.now(), 1)),
        startDate: startOfMonth(subMonths(Date.now(), 1)),
      };
    case DateRangeType.THIS_MONTH:
      return { endDate: anchorEnd, startDate: startOfMonth(anchor) };
    case DateRangeType.THIS_WEEK:
      return { endDate: anchorEnd, startDate: getWeekStart(anchor) };
    case DateRangeType.TODAY:
      return { endDate: endOfToday(), startDate: startOfToday() };
    case DateRangeType.YESTERDAY:
      return { endDate: endOfYesterday(), startDate: startOfYesterday() };
  }
};

export default dateRangeTypeToDateRange;
